export default "__VITE_ASSET__BLNska_A__"